import {
  ProjectFormatter,
  AmountFormatter,
  UserFormatter,
  TaskFormatter,
  StringFormatter,
  DateRangeFormatter,
  AdhocDescriptionFormatter,
  ExpenseCodeFormatter,
  BillingRateFormatter
} from '~/modules/billing-invoicing/common/columnFormatters';
import { Money as MoneyFormatter } from '~/modules/common/components/ListTable/renderers';
import DeleteLineItem from './DeleteLineItem';
import { QuantityFormatter } from './QuantityFormatter';
import QuantityRenderer from './QuantityRenderer';
import DescriptionRenderer from './DescriptionRenderer';
import RateRenderer from './RateRenderer';
import AmountRenderer from './AmountRenderer';

const getFormatters = (
  editable,
  hasAdhocLineItems,
  isPsaPrpCustomLineItemParityFlagEnabled
) => ({
  deleteIcon: DeleteLineItem,
  project: ProjectFormatter,
  amount:
    isPsaPrpCustomLineItemParityFlagEnabled && hasAdhocLineItems
      ? AmountRenderer
      : !editable
      ? MoneyFormatter
      : AmountFormatter,
  lineItemsTotal: MoneyFormatter,
  task: TaskFormatter,
  user: UserFormatter,
  billingType: StringFormatter,
  billingContractScriptName: StringFormatter,
  quantity:
    isPsaPrpCustomLineItemParityFlagEnabled && hasAdhocLineItems
      ? QuantityRenderer
      : QuantityFormatter,
  rate:
    isPsaPrpCustomLineItemParityFlagEnabled && hasAdhocLineItems
      ? RateRenderer
      : MoneyFormatter,
  description:
    isPsaPrpCustomLineItemParityFlagEnabled && hasAdhocLineItems
      ? DescriptionRenderer
      : AdhocDescriptionFormatter,
  timesheetPeriod: DateRangeFormatter,
  payCode: StringFormatter,
  role: StringFormatter,
  expenseCode: ExpenseCodeFormatter,
  billingRate: BillingRateFormatter
});

export default getFormatters;
